import { render, staticRenderFns } from "./OrderSync.vue?vue&type=template&id=1a6b3c5f&scoped=true&"
import script from "./OrderSync.vue?vue&type=script&lang=js&"
export * from "./OrderSync.vue?vue&type=script&lang=js&"
import style0 from "./OrderSync.vue?vue&type=style&index=0&id=1a6b3c5f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a6b3c5f",
  null
  
)

export default component.exports